module.exports = __webpack_public_path__ + "static/sewing-e2cb38476edd36d16dabc242392a068d.webm";